// @flow

/**
 * Module dependencies.
 */

import { BigNumber } from 'bignumber.js';
import { regex } from 'client/core/utils/regexes';

/**
 * Check email compliance.
 */

export const isEmail = (value: any): boolean => regex.email.test(value);

/**
 * Get numbers.
 */

export const getNumbers = (value: string | number) => value.toString().replace(regex.number, '');

/**
 * Check amount.
 */

export function checkAmount(amount: string | number, minimumValue: string) {
  const currentAmount = new BigNumber(amount);

  return currentAmount.isGreaterThanOrEqualTo(minimumValue);
}



// WEBPACK FOOTER //
// ../src/client/core/utils/forms.js